import React, { Component } from "react";
import "antd/dist/antd.css";
import { Row, Col, Spin, Card, Tag, Table } from "antd";
import { withRouter } from "react-router";
import { withAppContext } from "../../store/contextStore";
// import { Link } from 'react-router-dom';
import userLogo from "../../Images/user-logo.png";
import carrierTruck from "../../Images/carrier-truck.png";
import orderLogo from "../../Images/order-logo.png";
import orderStatus from "../../Images/order-status.png";
import AppConfigs from "../../Config/AppConfig";
import { list } from "../../api/Apis";
import moment from "moment";
import priceFormate, { formatPhoneNumber } from "../commonFunctions";

class CustomerNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLoadingStatus: false,
      notifications: [],
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
    };
  }

  componentDidMount = () => {
    this.setState({
      pageLoadingStatus: true,
    });
    if (!this.state.userDetails["recordStatus"]) {
      this.props.history.push("/carrier_app/review");
    }
    this.getAuditTrailsDetails();
  };

  getAuditTrailsDetails = () => {
    list("auditTrail", {
      typeofPage: "customerDetails",
      recordId: this.state.userDetails.carrierDetails?.id,
    })
      .then((details) => {
        if (details.success) {
          let totalAudit = details.data.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : -1
          );
          // totalAudit = details.data.filter(eachAudit=>eachAudit.auditTrailDetails.filter(o=>o.changedFieldName !== "recordId"))
          this.setState({
            notifications: totalAudit,
            pageLoadingStatus: false,
          });
        }
      })
      .catch((err) => console.log(err, "errrrr"));
  };

  openDeatilsPage = (recordType, recordId) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (userDetails.userProfile === "A" || userDetails.userProfile === "M") {
      if (recordType === "carrier") {
        this.props.history.push("/app/carriers/carrierdetails/" + recordId);
      } else if (
        recordType === "customer" ||
        recordType === "request_for_products" ||
        recordType === "request_location"
      ) {
        this.props.history.push("/app/customers/customerdetails/" + recordId);
      } else {
        this.props.history.push("/app/loads/loaddetails/" + recordId);
      }
    } else if (userDetails.userProfile === "CU") {
      this.props.history.push("/app/orders/orderdetails/" + recordId);
    } else if (userDetails.userProfile === "CA") {
      this.props.history.push("/carrier_app/myOrders/orderdetails/" + recordId);
    }

    // if (recordType === "order") {
    //   this.props.history.push("/app/loads/loaddetails/" + recordId);
    // } else if (recordType === "carrier") {
    //   this.props.history.push("/app/carriers/carrierdetails/" + recordId);
    // } else if (recordType === "customer") {
    //   this.props.history.push("/app/customers/customerdetails/" + recordId);
    // }
  };
  handleEventRender = (event, record) => {
    return (
      <>
        {event.changedFieldName === "firstName" ? (
          <>
            <p style={{ color: "black", fontSize: "14px" }}>
              First Name Changed from <b>{event.oldFields}</b> to{" "}
              <b>{event.modifiedField}</b>
            </p>
          </>
        ) : event.changedFieldName === "lastName" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Last Name Changed from <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "richTextEditior" ? (
          <div style={{ display: "flex" }}>
            Notes Changed from &nbsp;{" "}
            <div
              dangerouslySetInnerHTML={{
                __html: `${event.oldFields ? event.oldFields : ""}`,
              }}
            />{" "}
            &nbsp; to &nbsp;{" "}
            <div
              dangerouslySetInnerHTML={{
                __html: `${event.modifiedField ? event.modifiedField : ""}`,
              }}
            />
          </div>
        ) : event.changedFieldName === "presentCreditAmount" &&
          "orderId" in record === true ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            {"orderId" in record === true &&
              record.orderId !== "" &&
              "orderData" in record === true &&
              (record.orderData?.orderStatus === "OP" ||
                record.orderData?.orderStatus === "N") &&
              "orderData" in record === true &&
              "priceUpdatedStatus" in record.orderData === false && (
                <>
                  New Order <b>#{record.orderId}</b> Placed,{" "}
                </>
              )}{" "}
            {"orderData" in record === true &&
              record.orderData?.markAsPaid &&
              !record.orderData?.markAsInvoiced && (
                <>
                  Order #{record.orderId} <b>Marked as Paid</b>,{" "}
                </>
              )}
            {"orderData" in record === true &&
              record.orderData?.priceUpdatedStatus && (
                <>
                  Order <b>#{record.orderId}</b> Price Updated,{" "}
                </>
              )}
            {"orderData" in record === true &&
              record.orderData?.orderStatus === "D" &&
              !record.orderData?.markAsPaid &&
              !record.orderData?.markAsInvoiced && (
                <>
                  Order <b>#{record.orderId}</b> Marked as Delivered,{" "}
                </>
              )}
            Credit Available changed from{" "}
            <b>{event.oldFields !== "" && priceFormate(event.oldFields)}</b>
            {" to "}
            <b>{priceFormate(event.modifiedField)}</b>
          </p>
        ) : event.changedFieldName === "creditAmount" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Credit Limit updated from{" "}
            <b>{event.oldFields !== "" && priceFormate(event.oldFields)}</b>
            {" to "}
            <b>{priceFormate(event.modifiedField)}</b>
          </p>
        ) : event.changedFieldName === "address" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Address Changed from <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "phone" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Phone Changed from <b> {formatPhoneNumber(event.oldFields)} </b> to{" "}
            <b>{formatPhoneNumber(event.modifiedField)}</b>
          </p>
        ) : event.changedFieldName === "companyName" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Company Name Changed from <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "location" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            New Location Added <b>{event.modifiedField}</b>
          </p>
        ) : event.changedFieldName === "approvalStatus" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            {event.modifiedField === "A" ? (
              <b>Account approved </b>
            ) : (
              event.modifiedField === "F" && <b>Account Frozen</b>
            )}
          </p>
        ) : event.changedFieldName === "price" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            Product{" "}
            {"productName" in record === true && <b> {record.productName}</b>}{" "}
            Price Changes to <b>{event.oldFields}</b> to{" "}
            <b>{event.modifiedField}</b>
          </p>
        ) : // : event.changedFieldName === "productCode" ? (
        //   <p style={{ color: "black", fontSize: "14px" }}>
        //     <i> {event.productCode}</i> Product Item
        //     {event.modifiedField ? <b> Activated </b> : <b> Deactivated </b>}
        //   </p>
        // )
        event.changedFieldName === "isActive" ? (
          <p style={{ color: "black", fontSize: "14px" }}>
            <i> {event.productCode}</i> is
            {event.modifiedField ? <b> Activated </b> : <b> Deactivated </b>}
          </p>
        ) : (
          ""
        )}
      </>
    );
  };

  render() {
    const auditColumns = [
      {
        title: "DATE AND TIME",
        dataIndex: "createdAt",
        key: "createdAt",
        align: "left",
        width: "25%",
        render: (createdAt) => (
          <p style={{ color: "black", fontSize: "14px" }}>
            {moment(createdAt).format("MM/DD/YYYY hh:mm a")}
          </p>
        ),
      },
      {
        title: "ACTION DONE BY",
        dataIndex: "firstName",
        key: "createdAt",
        align: "left",
        width: "25%",
        render: (firstName, record) => (
          <p style={{ color: "black", fontSize: "14px" }}>
            {record.firstName + " " + record.lastName}
          </p>
        ),
      },
      {
        title: "EVENT",
        dataIndex: "auditTrailDetails",
        key: "auditTrailDetails",
        render: (auditTrailDetails, record) => (
          <>
            {record.auditTrailDetails.map((change) =>
              this.handleEventRender(change, record)
            )}
          </>
        ),
      },
    ];
    return (
      <div className="content-outer">
        <div className="content">
          <Spin spinning={this.state.pageLoadingStatus}>
            <Row>
              <Col lg={24} md={24} sm={24} xs={24}>
                <div
                  className="site-card-border-less-wrapper"
                  style={{ borderRadius: "10px", marginTop: "1vw" }}
                >
                  <Card title="Notifications" style={{ borderRadius: "10px" }}>
                    <Row gutter={16}>
                      <Table
                        columns={auditColumns}
                        dataSource={this.state.notifications}
                        size="middle"
                      />
                      {/* {customerAuditDetails.length > 0 &&
                    customerAuditDetails.map((eachAudit) => (
                      <>
                        <Col>
                          <h2>
                            {eachAudit.firstName + " " + eachAudit.lastName}
                          </h2>
                          {eachAudit.auditTrailDetails.length > 0 &&
                            eachAudit.auditTrailDetails.map((changes) => (
                              <>
                                <div
                                
                                className="ant-table-column-title"
                                >
                                  {changes.oldFields} changes to {" "}
                                  {changes.modifiedField}
                                </div>
                              </>
                            ))}
                        </Col>
                      </>
                    ))} */}
                    </Row>
                  </Card>
                </div>
              </Col>
              {/* <Col xs={24} sm={24} md={24} lg={24}>
                <h1 className="headings">Notifications</h1>
                {this.state.notifications.map((change) =>
                  change.auditTrailDetails.map((item) =>
                    // this.handleEventRender(item, change)
                    item.changedFieldName === "firstName" ? (
                      <>
                        <p style={{ color: "black", fontSize: "14px" }}>
                          First Name Changed from <b>{item.oldFields}</b> to{" "}
                          <b>{item.modifiedField}</b>
                        </p>
                      </>
                    ) : item.changedFieldName === "lastName" ? (
                      <p style={{ color: "black", fontSize: "14px" }}>
                        Last Name Changed from <b>{item.oldFields}</b> to{" "}
                        <b>{item.modifiedField}</b>
                      </p>
                    ) : item.changedFieldName === "richTextEditior" ? (
                      <div style={{ display: "flex" }}>
                        Notes Changed from &nbsp;{" "}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: `${item.oldFields ? item.oldFields : ""}`,
                          }}
                        />{" "}
                        &nbsp; to &nbsp;{" "}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: `${
                              item.modifiedField ? item.modifiedField : ""
                            }`,
                          }}
                        />
                      </div>
                    ) : item.changedFieldName === "presentCreditAmount" &&
                      "orderId" in change === true ? (
                      <p style={{ color: "black", fontSize: "14px" }}>
                        {"orderId" in change === true &&
                          change.orderId !== "" &&
                          "orderData" in change === true &&
                          (change.orderData?.orderStatus === "OP" ||
                            change.orderData?.orderStatus === "N") &&
                          "orderData" in change === true &&
                          "priceUpdatedStatus" in change.orderData ===
                            false && (
                            <>
                              New Order <b>#{change.orderId}</b> Placed,{" "}
                            </>
                          )}{" "}
                        {"orderData" in change === true &&
                          change.orderData?.markAsPaid &&
                          !change.orderData?.markAsInvoiced && (
                            <>
                              Order #{change.orderId} <b>Marked as Paid</b>,{" "}
                            </>
                          )}
                        {"orderData" in change === true &&
                          change.orderData?.priceUpdatedStatus && (
                            <>
                              Order <b>#{change.orderId}</b> Price Updated,{" "}
                            </>
                          )}
                        {"orderData" in change === true &&
                          change.orderData?.orderStatus === "D" &&
                          !change.orderData?.markAsPaid &&
                          !change.orderData?.markAsInvoiced && (
                            <>
                              Order <b>#{change.orderId}</b> Marked as
                              Delivered,{" "}
                            </>
                          )}
                        Credit Available changed from{" "}
                        <b>
                          {item.oldFields !== "" &&
                            priceFormate(item.oldFields)}
                        </b>
                        {" to "}
                        <b>{priceFormate(item.modifiedField)}</b>
                      </p>
                    ) : item.changedFieldName === "creditAmount" ? (
                      <p style={{ color: "black", fontSize: "14px" }}>
                        Credit Limit updated from{" "}
                        <b>
                          {item.oldFields !== "" &&
                            priceFormate(item.oldFields)}
                        </b>
                        {" to "}
                        <b>{priceFormate(item.modifiedField)}</b>
                      </p>
                    ) : item.changedFieldName === "address" ? (
                      <p style={{ color: "black", fontSize: "14px" }}>
                        Address Changed from <b>{item.oldFields}</b> to{" "}
                        <b>{item.modifiedField}</b>
                      </p>
                    ) : item.changedFieldName === "phone" ? (
                      <p style={{ color: "black", fontSize: "14px" }}>
                        Phone Changed from{" "}
                        <b> {formatPhoneNumber(item.oldFields)} </b> to{" "}
                        <b>{formatPhoneNumber(item.modifiedField)}</b>
                      </p>
                    ) : item.changedFieldName === "companyName" ? (
                      <p style={{ color: "black", fontSize: "14px" }}>
                        Company Name Changed from <b>{item.oldFields}</b> to{" "}
                        <b>{item.modifiedField}</b>
                      </p>
                    ) : item.changedFieldName === "location" ? (
                      <p style={{ color: "black", fontSize: "14px" }}>
                        New Location Added <b>{item.modifiedField}</b>
                      </p>
                    ) : item.changedFieldName === "approvalStatus" ? (
                      <p style={{ color: "black", fontSize: "14px" }}>
                        {item.modifiedField === "A" ? (
                          <b>Account approved </b>
                        ) : (
                          item.modifiedField === "F" && <b>Account Frozen</b>
                        )}
                      </p>
                    ) : item.changedFieldName === "price" ? (
                      <p style={{ color: "black", fontSize: "14px" }}>
                        Product{" "}
                        {"productName" in change === true && (
                          <b> {change.productName}</b>
                        )}{" "}
                        Price Changes from <b>{item.oldFields}</b> to{" "}
                        <b>{item.modifiedField}</b>
                      </p>
                    ) : item.changedFieldName === "productCode" ? (
                      <p style={{ color: "black", fontSize: "14px" }}>
                        <i> {item.productCode}</i> Product Item
                        {item.modifiedField ? (
                          <b> Activated </b>
                        ) : (
                          <b> Deactivated </b>
                        )}
                      </p>
                    ) : (
                      ""
                    )
                  )
                )}
              </Col> */}
            </Row>
          </Spin>
        </div>
      </div>
    );
  }
}
export default withAppContext(withRouter(CustomerNotifications));
